const siteUrl = 'https://d2bmyldsvz7gpo.cloudfront.net/'

module.exports = {
  /* Your site config here */
  siteMetadata: {
    title: 'Nissan',
    siteUrl:'https://d2bmyldsvz7gpo.cloudfront.net/',
    site_id: '686d3b7f0013e29758cbc6d6',
    api_base_url: 'https://api.dealermasters.com:4500',
    lead_url: 'https://leads.dealermasters.com/leads',
    master_sites: ['63222a9910c6d3e9abe42c44','63222b5c10c6d3e9abe42c45','63dd30f20439a71a0bd5b439'],
    autocheck_url: 'https://n1u6ywp1bf.execute-api.us-east-2.amazonaws.com/default/AutoCheckFastLink',
      quickgenAPI: 'https://dev.mxsapi.com',
      imageBaseURL: 'https://images.mxssolutions.com',
      opensearchAPI: 'https://tehy4uupcb.execute-api.us-east-2.amazonaws.com/opensearch-inventory-search-api/'// DEV: 'https://q0mj4jv9i6.execute-api.us-east-2.amazonaws.com/opensearch-inventory-search-api/'
  },
  plugins: [
    'gatsby-plugin-react-helmet',
    {
      resolve: "gatsby-plugin-force-trailing-slashes"
    },
    {
      resolve: 'gatsby-plugin-advanced-sitemap',
      options: {
      },
    },
    {
      resolve: "gatsby-plugin-emotion"
    },
    {
      resolve: "gatsby-transformer-json"
    },
    {
      resolve: "gatsby-plugin-sass",
      options: {
        cssLoaderOptions: {
          camelCase: false,
        },
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /\.inline\.svg$/
        }
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `src`,
        path: `${__dirname}/src/`
      }
    },
    {
      resolve: 'gatsby-plugin-s3',
      options: {
        bucketName: 'mxs-5257aa4a-1986-4bba-a967-d1a2c643830d-prodsite'
      }
    },
    `gatsby-transformer-json`,
    {
      resolve: require.resolve('./plugins/gatsby-source-dynamodb-query'),
      options: {
        typeName: 'inventory',
        region: 'us-east-2',
        tableName: 'AdjustedInventory',
        dealerId: ['44506','115452','96264','37180']//126024
      }
    },
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        icon: 'static/favicon.png'
      }
    },{
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: 'https://d2bmyldsvz7gpo.cloudfront.net/',
        sitemap: 'https://d2bmyldsvz7gpo.cloudfront.net/sitemap-pages.xml',
        policy: [{ userAgent: '*', allow: '/' }]
      }
    }
  ]
}